import { Alert, Grid, LinearProgress, } from '@mui/material';
import { Box } from '@mui/system'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom'
// import Footer from '../pages/Footer'
import Navbar from '../pages/Navbar';
import Sidebar from '../pages/Sidebar';
import { useTheme } from '@emotion/react'
import Footer from '../pages/Footer';
import useAxios from '../hooks/use-axios';
import { useEffect, useState } from 'react';
import moment from 'moment';

const MainLayout = () => {
    const theme = useTheme()
    const isLoading = useSelector(state => state.ui.isLoading)
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    const lastLogIn = localStorage.getItem('lastLogIn')

    const axios = useAxios({ enableLoader: false });
    const [isWrongClock, setIsWrongClock] = useState(false)
    useEffect(() => {
        const intervalControl = setTimeout(async () => {
            const resp = await axios.get('/dashboard/current_time/')
            console.log("🚀 ~ file: App.js:156 ~ intervalControl ~ moment().diff(moment(resp.data.data.current_time), 'seconds'):", moment().diff(moment(resp.data.data.current_time), 'seconds'))
            if (Math.abs(moment().diff(moment(resp.data.data.current_time), 'seconds')) > 120) {
                setIsWrongClock(true)
            }
        }, 3000)

        return () => {
            clearInterval(intervalControl);
        }
    }, [])

    return (
        lastLogIn && !isNaN(lastLogIn) && (new Date() < new Date(Number(lastLogIn))) && isLoggedIn === "true" ?
            <Box bgcolor="background.default" color="text.primary" sx={{ position: "relative" }}>
                {isWrongClock && <Alert severity="warning" onClose={() => { setIsWrongClock(false) }}>It seems like your clock doesn't have the correct time, which may affect your app experience.</Alert>}
                <Navbar />
                {isLoading && <LinearProgress sx={{ position: "absolute", width: "100%", zIndex: "999" }} />}
                <Grid container spacing={2} sx={{ marginTop: '0px', minHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" } }}>
                    <Grid bgcolor={theme.palette.primary.main} item xs={2} sx={(theme) => ({
                        display: { xs: "none", lg: "block" }, maxHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" },
                    })}>
                        <Sidebar />
                    </Grid>
                    <Grid item xs={12} lg={10} sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", paddingTop: "0px !important", paddingLeft: { xs: "16px", lg: "0px !important" }, overflowY: "auto", overflowX: "hidden", maxHeight: { xs: "calc(100vh - 56px)", sm: "calc(100vh - 64px)" } }} className="overflow-scroll">
                        <Outlet />
                        <Footer />
                    </Grid>
                </Grid>
            </Box>
            :
            <Navigate to="/accounts/signin" replace />
    )
}

export default MainLayout